import classNames from "classnames";
import { motion } from "framer-motion";
import "./index.css";

export const Quiz = ({ id, children, chatStarted, isChatQuestion = false }) => {
  return (
    <motion.div
      key={id}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={classNames(
        "quiz min-h-full sm:max-h-full sm:h-full",
        "sm:rounded-lg sm:border sm:border-brown-gold sm:bg-white", //sm:m-auto sm:h-[92%] sm:w-[92%]
        { "bg-[#000] sm:bg-[#FFFFFF] overflow-hidden" : isChatQuestion },
        { "bg-[#FFFFFF] sm:bg-[#FFFFFF]" : !isChatQuestion },

      )}
    >
      {children}
    </motion.div>
  );
};
